import React from 'react';
import SearchResults from './SearchResults';
import './Hero.css';

const Search = props => {
  console.log("search props", props);
    return (
      <div className={props.className}>
        {/* <SearchQueryHeader
          headerLabel={props.headerLabel}
          searchCriteria={props.searchCriteria}
        /> */}
        <SearchResults
          getReleaseYear={props.getReleaseYear}
          searchResults={props.searchResults}
        />
      </div>
    );
};

export default Search;
